import { render, staticRenderFns } from "./DxPopupWorkOrder.vue?vue&type=template&id=04fff062&scoped=true&"
import script from "./DxPopupWorkOrder.vue?vue&type=script&lang=js&"
export * from "./DxPopupWorkOrder.vue?vue&type=script&lang=js&"
import style0 from "./DxPopupWorkOrder.vue?vue&type=style&index=0&id=04fff062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fff062",
  null
  
)

export default component.exports